import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export class SwiperCarousel {
	navigationSelector = '.swiper-carousel-navigation';
	prevSelector = '.js-swiper-prev';
	nextSelector = '.js-swiper-next';

	constructor(container, options) {
		this.container = container;
		if (!this.container) return;

		this.options = options;

		this.init();
	}

	init() {
		const navigation = this.getNavigationElement();

		this.swiper = new Swiper(this.container, {
			modules: [Navigation],
			slidesPerView: 'auto',
			spaceBetween: 10,
			watchSlidesProgress: true,
			watchOverflow: true,
			grabCursor: true,
			slidesOffsetBefore: 10,
			slidesOffsetAfter: 10,
			navigation: {
				prevEl: navigation.querySelector(this.prevSelector),
				nextEl: navigation.querySelector(this.nextSelector),
			},
			breakpoints: this.options?.breakpoints || this.getDefaultBreakpoints(),
			on: {
				lock: (swiper) => swiper.slideTo(0, 0),
			},
		});
	}

	getNavigationElement() {
		const carousel = this.container.closest('.swiper-carousel');

		if (carousel) {
			const navigation = carousel.querySelector(this.navigationSelector);
			if (navigation) return navigation;
		}

		return this.container.closest('.section')?.querySelector(this.navigationSelector) ?? null;
	}

	getDefaultBreakpoints() {
		return {
			[vars.breakpoint.desktop]: {
				slidesOffsetAfter: 0,
				slidesOffsetBefore: 0,
				slidesPerView: 5,
			},
		};
	}
}
